import React, { type PropsWithChildren } from 'react';
import { StyleSheet, View } from 'react-native';

import { theme } from '@garnish/constants';

import { Container, useResponsive } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const ReorderRailContainer = (props: PropsWithChildren) => {
  const { children } = props;

  const { match } = useResponsive();

  // ─── Styles ──────────────────────────────────────────────────────────

  const outerContainerStyles = match([styles.outerContainerXS, styles.outerContainerSM]);
  const containerStyles = match([styles.containerXS, styles.containerSM]);

  // ─────────────────────────────────────────────────────────────────────

  return (
    <View style={outerContainerStyles}>
      <Container style={containerStyles}>{children}</Container>
    </View>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  outerContainerXS: {
    paddingVertical: theme.spacing['4'],
  },
  outerContainerSM: {
    borderBottomWidth: 1,
    borderColor: theme.colors.OPACITY.BLACK.ALMOST_TRANSPARENT,
    paddingVertical: theme.spacing['8'],
  },
  containerXS: {
    gap: theme.spacing['1'],
    paddingHorizontal: 0, // override default spacing
  },
  containerSM: {
    gap: theme.spacing['6'],
    paddingHorizontal: 0, // override default spacing
  },
});
